import { useState } from 'react';
import SelectBox from '../../../shared/controls/form/selectBox';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

const CreateTemplate = ({ templatePageType, handleClose, handleChange }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  const options = [
    { value: 'Lead', label: 'Leads' },
    { value: 'Contact', label: 'Contacts' },
  ];
  const navigate = useNavigate();
  const handleSelect = (selected) => {
    setSelectedOption(selected);
    setErrorMsg(''); // Clear error message on selection
  };

  const handleSave = () => {
    if (templatePageType === 'new')
      navigate('/settings/templateGallery/newTemplate', {
        state: { module: selectedOption.value },
      });
    else
      navigate('/settings/templateGallery', {
        state: selectedOption.value,
      });
  };

  return (
    <Formik>
      <form>
        <div id="genricPopup" className="templatePopup">
          <div className="popup-overlay">
            <div className="popup">
              {/* Popup Header */}
              <div className="popup-header">
                <h4 className="popup-title">
                  {templatePageType === 'new' ? 'Create' : 'Display'} Email Template
                </h4>
                <button className="custom-btn-close" onClick={handleClose}></button>
              </div>

              {/* Popup Body */}
              <div className="popup-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="input-container">
                      <SelectBox
                        label={'Select Module'}
                        name={'module'}
                        placeholder={'Select'}
                        isRequired={false}
                        disabled={''}
                        selectedOptions={selectedOption}
                        handleSelect={handleSelect}
                        options={options}
                        errormsg={errorMsg}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            borderWidth: state.isFocused ? '1px' : base.borderWidth,
                            boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
                            transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                            '&:hover': {
                              borderColor: '#365397',
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? '#DEEBFF'
                              : state.isFocused
                                ? '#DEEBFF'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#222'
                              : state.isFocused
                                ? '#222'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Popup Footer */}
              <div className="popup-footer">
                <button type="button" className="btn btn-outline-primary" onClick={handleClose}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Formik>
  );
};
export default CreateTemplate;
